import * as React from "react";
import { useStaticQuery, graphql, Script } from "gatsby";
import { CountryBase } from "../../templates/fragments/country";
import { RegionBase, RegionStub } from "../../templates/fragments/region";
import { DesktopFooter } from "./footer/desktop";
import { MobileFooter } from "./footer/mobile";

export const Footer = () => {
    const data: {
        bestDestinations: {
            bestCountries: CountryBase[];
            bestRegions: RegionStub[];
        };
    } = useStaticQuery(graphql`
        {
            bestDestinations: commonDataJson {
                bestCountries {
                    ...CountryBase
                }
                bestRegions {
                    ...RegionStub
                }
            }
        }
    `);

    return (
        <footer>
            <div className="md:hidden">
                <MobileFooter
                    bestCountries={data.bestDestinations.bestCountries}
                    bestRegions={data.bestDestinations.bestRegions}
                />
            </div>
            <div className="mdmax:hidden">
                <DesktopFooter
                    bestCountries={data.bestDestinations.bestCountries}
                    bestRegions={data.bestDestinations.bestRegions}
                />
            </div>
            <Script
                type="text/javascript"
                async
                src="https://btloader.com/tag?o=5698917485248512&upapi=true&domain=sunheron.com"
            />
            <Script>
                {`
                !function(){"use strict";var e;e=document,function(){var t,n;function r(){var t=e.createElement("script");t.src="https://cafemedia-com.videoplayerhub.com/galleryplayer.js",e.head.appendChild(t)}function a(){var t=e.cookie.match("(^|[^;]+)\s*__adblocker\s*=\s*([^;]+)");return t&&t.pop()}function c(){clearInterval(n)}return{init:function(){var e;"true"===(t=a())?r():(e=0,n=setInterval((function(){100!==e&&"false" !== t || c(), "true" === t && (r(), c()), t = a(), e++}), 50))}}}().init()}();
                `}
            </Script>
        </footer>
    );
};
